'use client';

import {
  apiRoutes,
  publicHttpClient,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export interface LoginWithSocial {
  google_token?: string;
  facebook_token?: string;
  source?: string;
  campaign?: string;
  mobile?: string;
  name?: string;
  email?: string;
  facebook_id?: null;
  google_id?: null;
  ref_code?: string;
  ref_name?: string;
  imei: string;
}

export enum LoginWithSocialErrorCode {
  GoogleTokenExpired = 'GOOGLE_TOKEN_EXPIRED',
  FacebookTokenExpired = 'FACEBOOK_TOKEN_EXPIRED',
  NotAuthorized = 'NOT_AUTHORIZED',
  TokenNotFound = 'TOKEN_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND',
}

export type LoginWithSocialError = DefaultQueryError<LoginWithSocialErrorCode>;

export interface LoginWithSocialResponse {
  // In-case has been registered before
  token: string;
  refresh_token: string;
  firebase_token?: string;
  user: {
    _id: string;
    language: string;
    email: string;
    id: string;
    name: string;
    type: string;
    city_id: string[];
  } & Record<string, any>;
  // In-case do not register before
  email?: string;
  id?: string;
  name?: string;
  type?: string;
  city_id?: string[];
}

export const socialLoginFn = async (body: LoginWithSocial) => {
  const response = await publicHttpClient.post<LoginWithSocialResponse>(
    apiRoutes.auth.socialLogin,
    {
      fcm: true,
      format: 'json',
      type: 'web',
      push: 'web',
      ...body,
    }
  );
  return response.data;
};

export const useSocialLoginMutation = (
  opts?: UseMutationOptions<
    LoginWithSocialResponse,
    LoginWithSocialError,
    LoginWithSocial
  >
) =>
  useMutation<LoginWithSocialResponse, LoginWithSocialError, LoginWithSocial>({
    mutationKey: [apiRoutes.auth.socialLogin],
    mutationFn: socialLoginFn,
    ...opts,
  });
